import "@/App.css";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import Portfolio from "@/components/landing/Portfolio";
import EventFestival from "@/components/landing/EventFestival";
import { Stats } from "@/components/landing/Highlights";
import Footer from "@/components/landing/Footer";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <EventFestival />
        <Portfolio />
        <Stats />
      </main>
      <Footer />
    </div>
  );
}

export default App;
